import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const features = [
  {
    key: "feature.1",
    href: "/usfans-spreadsheet-guide",
    tone: "bg-primary-100 text-primary-700",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20photograph%20of%20an%20open%20laptop%20showing%20a%20tidy%20spreadsheet%20with%20a%20small%20notebook%20and%20a%20ceramic%20mug%20on%20a%20light%20oak%20desk%20soft%20daylight%20gentle%20shadows%20clean%20minimal%20workspace%20photography%20calm%20premium%20atmosphere&width=600&height=400&seq=usfans-feat-spreadsheet&orientation=landscape&nocache=true",
  },
  {
    key: "feature.2",
    href: "/usfans-qc",
    tone: "bg-accent-100 text-accent-900",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20close%20up%20of%20a%20magnifying%20glass%20held%20over%20folded%20textured%20fabric%20with%20soft%20window%20light%20and%20gentle%20shadows%20clean%20minimal%20quality%20inspection%20concept%20photography%20calm%20premium%20atmosphere%20warm%20tones&width=600&height=400&seq=usfans-feat-qc&orientation=landscape&nocache=true",
  },
  {
    key: "feature.3",
    href: "/usfans-w2c",
    tone: "bg-secondary-100 text-secondary-900",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20still%20life%20of%20two%20linked%20paper%20chain%20rings%20and%20a%20small%20open%20notebook%20on%20a%20light%20neutral%20surface%20soft%20daylight%20gentle%20shadows%20clean%20minimal%20connection%20and%20links%20concept%20photography%20calm%20premium%20atmosphere&width=600&height=400&seq=usfans-feat-w2c&orientation=landscape&nocache=true",
  },
  {
    key: "feature.4",
    href: "/usfans-shipping-cost",
    tone: "bg-primary-100 text-primary-700",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20still%20life%20of%20a%20single%20kraft%20cardboard%20shipping%20box%20sealed%20with%20tape%20beside%20a%20roll%20of%20packing%20paper%20on%20a%20light%20wooden%20table%20soft%20window%20light%20gentle%20shadows%20clean%20minimal%20logistics%20photography%20calm%20premium%20atmosphere&width=600&height=400&seq=usfans-feat-shipping&orientation=landscape&nocache=true",
  },
  {
    key: "feature.5",
    href: "/usfans-review",
    tone: "bg-accent-100 text-accent-900",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20still%20life%20of%20a%20small%20stack%20of%20rating%20cards%20with%20five%20gold%20stars%20drawn%20on%20the%20top%20card%20resting%20on%20a%20soft%20neutral%20surface%20with%20soft%20daylight%20gentle%20shadows%20clean%20minimal%20review%20and%20feedback%20concept%20photography%20calm%20premium%20atmosphere&width=600&height=400&seq=usfans-feat-review&orientation=landscape&nocache=true",
  },
  {
    key: "feature.6",
    href: "/usfans-safety",
    tone: "bg-secondary-100 text-secondary-900",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20editorial%20still%20life%20of%20a%20small%20brass%20padlock%20resting%20beside%20a%20soft%20green%20leaf%20on%20a%20light%20neutral%20linen%20surface%20with%20soft%20window%20light%20gentle%20shadows%20clean%20minimal%20safety%20and%20protection%20concept%20photography%20calm%20premium%20atmosphere&width=600&height=400&seq=usfans-feat-safety&orientation=landscape&nocache=true",
  },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("features.title")}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {t("features.subtitle")}
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f) => (
          <Link
            key={f.key}
            to={f.href}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={f.image}
                alt={t(`${f.key}.title`)}
                title={`${t(`${f.key}.title`)} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <span className={`flex w-11 h-11 items-center justify-center rounded-lg ${f.tone}`}>
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-800">
                {t(`${f.key}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {t(`${f.key}.desc`)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}